import { injectIntl } from 'react-intl';

// Components
import DateFooter from './DateFooter';

export default injectIntl(DateFooter);



// WEBPACK FOOTER //
// ./src/components/atoms/DateFooter/DateFooterContainer.js